import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

function RecipientSignupQuestions({
  setValidNPO,
  isValidNPO,
  setValidFoodHandler,
  isValidFoodHandler,
  setValidRefrigerator,
  isValidRefrigerator,
}) {
  const showBackToHomeButton = isValidNPO === false
    || isValidFoodHandler === false
    || isValidRefrigerator === false;

  const showIntercom = () => {
    Intercom('showMessages');
  };

  return (
    <div>
      <fieldset className="input-container qualifying-question">
        <legend className="label fs-6">
          1. Are you a non-profit organization?
        </legend>
        <p className="help-text">
          A valid non-profit organization is certified as a 501(c)(3).
        </p>

        <Form.Check
          type="radio"
          name="validNPO"
          className="rp-recipient"
          id="validNPO-y"
          value="yes"
          label="Yes, I am a valid 501(c)(3) non-profit organization."
          onChange={setValidNPO}
        />
        <Form.Check
          type="radio"
          name="validNPO"
          className="rp-recipient"
          id="validNPO-n"
          value="no"
          label="No, I am not."
          onChange={setValidNPO}
        />
        { isValidNPO === false ? (
          <div className="invalid-text-container alert-text">
            Sorry, Replate only donates food to non-profit organizations.
          </div>
        ) : null }

      </fieldset>

      <fieldset className="input-container qualifying-question">
        <legend className="label fs-6">
          2. Do you have a valid food handlers certification?
        </legend>
        <br />
        <Form.Check
          type="radio"
          name="validFoodHandler"
          id="validFoodHandler-y"
          className="rp-recipient"
          value="yes"
          onChange={setValidFoodHandler}
          label="Yes, I have a food handlers certification that is valid in my
        state and is not expired."
        />
        <Form.Check
          type="radio"
          name="validFoodHandler"
          id="validFoodHandler-n"
          className="rp-recipient"
          value="no"
          onChange={setValidFoodHandler}
          label="No, I do not have a valid food handlers certification."
        />
        { isValidFoodHandler === false ? (
          <div className="invalid-text-container alert-text">
            <span>No problem! Talk to the</span>
            {' '}
            <button
              type="button"
              className="fw-bold text-danger text-decoration-underline p-0 bg-transparent border-0"
              onClick={showIntercom}
            >
              Replate Support Team
            </button>
            {' '}
            about
            how to get yours in just a few hours.
          </div>
        ) : null}

      </fieldset>

      <fieldset className="input-container qualifying-question">
        <legend className="label fs-6">
          3. Does your organization have refrigeration and proper food heating?
        </legend>
        <br />
        <Form.Check
          type="radio"
          name="validRefrigerator"
          id="validRefrigerator-y"
          className="rp-recipient"
          value="yes"
          onChange={setValidRefrigerator}
          label="Yes, we have the ability to refrigerate and safely heat prepared
        food delivered by Replate."
        />
        <Form.Check
          type="radio"
          name="validRefrigerator"
          className="rp-recipient"
          id="validRefrigerator-n"
          value="no"
          onChange={setValidRefrigerator}
          label="No, we do not have refrigeration and heating at our facility."
        />
        { isValidRefrigerator === false ? (
          <div className={`invalid-text-container alert-text
          ${isValidRefrigerator === false}`}
          >
            Replate delivers prepared food that must be stored and heated
            according to food safety standards.
          </div>
        ) : null }
      </fieldset>
      { showBackToHomeButton && (
      <div>
        <a href="/" className="btn btn-recipient mt-1">
          Back to Home
        </a>
      </div>
      )}
    </div>
  );
}

RecipientSignupQuestions.propTypes = {
  isValidFoodHandler: PropTypes.bool.isRequired,
  isValidNPO: PropTypes.bool.isRequired,
  isValidRefrigerator: PropTypes.bool.isRequired,
  setValidFoodHandler: PropTypes.func.isRequired,
  setValidNPO: PropTypes.func.isRequired,
  setValidRefrigerator: PropTypes.func.isRequired,
};

export default RecipientSignupQuestions;
